import { render, staticRenderFns } from "./productOptions.vue?vue&type=template&id=158e1e9d"
import script from "./productOptions.vue?vue&type=script&lang=js"
export * from "./productOptions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports